import { useContext, useState } from 'react';
import _ from 'lodash';
import NoDataForSelection from 'components/atoms/NoDataForSelection';
import TileButton from 'components/atoms/TileButton';
import { FilterContextData } from 'contexts/FilterContext';
import { trackEventMixpanel } from 'utils/mixpanel';
import { OPPORTUNITY_IDENTIFICATION_TAB_CHANGED } from 'utils/mixpanelEventNames';
import OpportunityElasticityDriver from 'components/organism/OpportunityIdentification/ElasticityDriver/OpportunityElasticityDriver';
import Loader from 'components/molecules/Loader';
import { calculateContainerHeight } from 'utils/helperMethods';
import OpportunityElasticityComparision from 'components/organism/OpportunityIdentification/ElasticityComparision/OpportunityElasticityComparision';

export const commonClassName = 'border  border-borderLinePurpuleAlt p-4 rounded-lg';
export const commonHeaderClass = 'font-medium font-xl m-0 text-headerColor';

export const absTileData = [
    { key: 'elasCompar', label: 'Elasticity Comparison' },
    { key: 'elasDriver', label: 'Elasticity Driver' },
];

const opportunityIdentificationHeader = 'Opportunity Identification';
const commonLoaderHeight = Math.max(450, calculateContainerHeight(1, 33 + 16 * 2) - 200);

const OpportunityIdentification = () => {
    const { allDimAndAttributeTypeList, idForRestOfComponentLoading, filterNullError } = useContext(FilterContextData);

    const [absTile, setAbsTile] = useState(absTileData[0]);

    const commonLoading = idForRestOfComponentLoading || (allDimAndAttributeTypeList?.loading as boolean);

    if (commonLoading)
        return (
            <div
                style={{
                    height: commonLoaderHeight + 150,
                }}
                className={`flex justify-center items-center rounded bg-white `}
            >
                <Loader />
            </div>
        );

    const chartHeight = calculateContainerHeight(1, 200);

    return (
        <section className={` ${commonClassName} bg-white`}>
            {filterNullError ? (
                <NoDataForSelection />
            ) : (
                <div>
                    <div className="flex justify-between items-center">
                        <div className="flex gap-4 items-center">
                            <h2 className={commonHeaderClass}>{opportunityIdentificationHeader}</h2>
                            <TileButton
                                disabled={commonLoading}
                                data={absTileData}
                                activeKey={absTile.key}
                                onClick={(item: any) => {
                                    trackEventMixpanel(OPPORTUNITY_IDENTIFICATION_TAB_CHANGED, {
                                        tabName: item.label,
                                    });
                                    setAbsTile(item);
                                }}
                                style={{ marginRight: 16 }}
                            />
                        </div>
                    </div>

                    {commonLoading ? (
                        <div className={`${commonClassName} bg-white`} style={{ height: chartHeight + 50 }}>
                            <Loader />
                        </div>
                    ) : (
                        <>
                            {absTile.key === absTileData[0].key ? (
                                <OpportunityElasticityComparision />
                            ) : (
                                <OpportunityElasticityDriver />
                            )}
                        </>
                    )}
                </div>
            )}
        </section>
    );
};

export default OpportunityIdentification;
